




































































































import Vue from 'vue'

import CategoryCircle from './category-circle.vue'
import ResultList from '../ResultList.vue'

import { corpMixins } from '@/mixins/corp-mixins'
import { isMobile } from '@/lib/helpers/index.ts'

export default Vue.extend({
  mixins: [corpMixins],
  data() {
    return {
      windowWidth: window.innerWidth,
      checkPrivate: this.isPrivate,
      mobileScreen: isMobile()
    }
  },
  props: {
    isPrivate: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object as Prop<api.content.Content>,
      required: true
    },
    unit: {
      type: Object as Prop<api.unit.GetUnitResponseData>,
      required: true
    },
    rate: {
      type: Number as Prop<number>,
      required: true
    },
    previousRate: {
      type: Number as Prop<number>
    },
    correctAnswerRate: {
      type: Number as Prop<number>
    },
    categoryRates: {
      type: Array as Prop<api.unitImpl.CategoryRate[]>,
      required: true
    },
    questions: {
      type: Array as Prop<api.unitImpl.Question[]>,
      required: true
    }
  },

  components: {
    CategoryCircle,
    ResultList
  },

  computed: {
    score(): number {
      return this.questions.filter(q => q.impl.correct).length
    },
    isMobile(): Boolean {
      return this.windowWidth <= 400
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  methods: {
    clickCheckIcon(question: api.unitImpl.Question) {
      this.$emit('click-check-icon', question)
    },
    setPrivate() {
      this.$emit('setPrivate', this.checkPrivate)
    }
  }
})
